import React, { memo, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ChartPie from '../../../../shared/components/ChartPie';
import {
  formatterPercentPieChartDataSet,
  getTranslationAnswerByQuantity,
} from '../../../../shared/utils/smartutils';

const SummaryObjectiveAnswer = ({ answer }) => {
  const htmlRef = useRef(null);
  const { question, chartData } = answer;

  const options = {
    animation: {
      duration: 0,
    },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      datalabels: {
        formatter: formatterPercentPieChartDataSet,
        color: 'white',
        anchor: 'center',
        align: 'center',
        offset: 10,
      },
    },
  };

  const hasData = () => {
    return !!chartData && chartData.length;
  };

  const getTotalAnswered = () => {
    return question.numberOfAnswer;
  };

  const getLabels = () => {
    let labels = [];
    if (hasData()) {
      labels = chartData.map((data) => data.label);
    }
    return labels;
  };

  const getNumbersChart = () => {
    let labels = [];
    if (hasData()) {
      labels = chartData.map((data) => data.value);
    }
    return labels;
  };

  useEffect(() => {
    if (question && htmlRef) {
      htmlRef.current.innerHTML = question.description;
    }
  }, [question]);

  return (
    <div className="mb-3 bg-light p-3">
      <div ref={htmlRef} className="mb-3" />
      <div className="mb-3">
        {`${getTotalAnswered()} ${getTranslationAnswerByQuantity(
          getTotalAnswered()
        )}`}
      </div>
      <div className="d-flex align-items-center">
        <div className="h-100 flex-2">
          <ChartPie
            dataLabels={getLabels()}
            numbersChart={getNumbersChart()}
            options={options}
            height={200}
          />
        </div>
      </div>
    </div>
  );
};

SummaryObjectiveAnswer.propTypes = {
  answer: PropTypes.shape({
    question: PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.number,
      numberOfAnswer: PropTypes.number,
      type: PropTypes.string,
    }),
    chartData: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        responsible: PropTypes.string,
        value: PropTypes.number,
      })
    ),
  }).isRequired,
};

export default withTranslation('common')(memo(SummaryObjectiveAnswer));
